import styled, { css } from 'styled-components'
import Media from 'components/common/Media'

export const Column = styled.div`
  ${props => props.responsive && css`
    ${Media.desktop`
      display: inline-block;
      vertical-align: top;
      width: 50%;
    `}
  `}
  ${props => props.half && css`
    display: inline-block;
    vertical-align: top;
    width: 50%;
  `}
  ${props => props.centered && css`
    text-align: center;
  `}
  ${Media.desktop`
    padding: ${props => props.padding_desktop || '0'};
  `}
  ${Media.mobile`
    padding: ${props => props.padding_mobile || '0'};
  `}
  margin: ${props => props.margin || '0'};
`
